import type { AnyUser } from "@megaron/access-control";
import { HttpAction, HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";
import { Serializers } from "@megaron/serializers";

const cubeLoadBody = Serializers.object({
  query: Serializers.identity<unknown>(),
});

export const cubeHttpService = HttpService({
  cubeLoad: HttpAction({
    path: "/load",
    method: "post",
    requiresAuth: true,
    bodySerializer: cubeLoadBody,
    valueSerializer: Serializers.identity<unknown>(),
    errorSerializer: Serializers.string,
    resultWrapper: false,
  }),
});

export type CubeHandlers = HandlerMap<typeof cubeHttpService, AnyUser>;
